import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";
import resume from '../../../assets/Resume/Merajul_Resume.pdf';
import CV from '../../../assets/Resume/Merajul_CV.pdf'


export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://www.facebook.com/merajoulehasan.utsho" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="facebook">
                <i className="fa fa-facebook-square" />
              </a>
              <a href="https://www.instagram.com/h_m_merajoule_hasasn/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Instagram">
                <i className="fa fa-instagram" />
              </a>
              <a href="https://www.linkedin.com/in/h-m-merajul-hasan-62687b23a/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="linkedin">
                <i className="fa fa-linkedin" />
              </a>
              <a href="https://github.com/HNMerajulhasan" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Github">
                <i className="fa fa-github" />
              </a>
      
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text"><b>H.M Merajul Hasan</b></span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Web Dev 😎",
                    2000,
                    "ReactJS Developer 💻",
                    2000,
                    "Mern stack Developer 📱",
                    2000,
                    "Front End Developer🔴",
                    2000,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Knack of building applications with front and back end operations.
            </span>
          </div>

          <div className="profile-options">
          
               <button className="btn primary-btn"
             onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
             > Hire Me </button>
            
           <a href={resume} className="get_resume" download="Merajul_Resume.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
             
            <a href={CV} className="get_resume" download="Merajul_CV.pdf">
              <button className="btn highlighted-btn">Get CV</button>
            </a>   

          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
